import carIcon from '../../assets/car.svg'
import audioWaveIcon from 'shared/assets/icons/audio-wave.svg'
import microphoneIcon from 'shared/assets/icons/microphone.svg'

export const showcaseFeatureCards = [
  {
    icon: carIcon,
    text: 'Vehicle-specific acoustic modeling',
  },
  {
    icon: audioWaveIcon,
    text: 'Typical compensation - 5-12 dB attenuation',
  },
  {
    icon: microphoneIcon,
    text: 'Optimization - Voice intelligibility',
  },
]
